<template>
  <section class="root">
    <div class="banner">
      <img class="person" :src="contactPerson" alt="Contact Person" v-if="contactPerson" width="90" height="90" />
      <div class="content">
        <p class="title">{{ blok.title }}</p>
        <p class="subtitle">{{ blok.subtitle }}</p>
        <div class="cta">
          <cms-link v-for="a in blok.ctas" :key="a._uid" :blok="a"></cms-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import cms from "@/mixins/cms.js";
export default {
  mixins: [cms],
  name: "cms-consultation-banner",
  computed: {
    contactPerson() {
      return this.blok.consultant?.filename ? this.transformImage(this.blok.consultant.filename, "150x150", true) : null
    },
  }
}
</script>


<style scoped>
div.banner {
  display: grid;
  max-width: 700px;
  margin: 0 auto;
  padding: 1rem;
  gap: 1rem;
  grid-template-rows: 100px 1fr;
  background-color: var(--crf-bg-high);
  border-radius: 8px;
  box-shadow: var(--crf-shadow);
}

div.banner img {
  border-radius: 50%;
  aspect-ratio: 1/1;
  display: block;
  width: 90px;
  justify-self: center;
  align-self: center;
}

div.content {
  display: flex;
  align-items: center;
  flex-direction: column;
  color: var(--crf-text);
}

div.content p {
  margin: 0;
  padding: 0;
  text-align: center;

}

div.content p.title {
  font-family: 'Inter';
  font-weight: 700;
  color: var(--crf-primary);
  font-size: var(--fs-300);
}

div.content p.subtitle {
  color: var(--crf-text);
  font-size: 0.9rem;
  margin-block: 0.5rem;
  text-align: left;
}

div.content div.cta {
  margin-top: 0.6rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

@media screen and (min-width: 768px) {
  div.banner {
    grid-template-rows: 1fr;
    grid-template-columns: 100px 1fr;
  }

  div.content div.cta {
    flex-direction: row;
  }

  div.content {
    align-items: start;
  }
}
</style>
